import Config from "../config";
import { PostCall } from "./helper";

const URLS = {
  REQUEST_CALL_WHITELIST: `${Config.BASE_API_URL}/v4/app:website/dialer/allow_agent_connection/`,
};

export const RequestCallWhitelist = async (customerId?: number) => {
  let data = { customer_id: customerId };
  return await PostCall(
    URLS.REQUEST_CALL_WHITELIST,
    data,
    Config.DEFAULT_HEADER
  );
};
